import { render, staticRenderFns } from "./RateView.vue?vue&type=template&id=5e368202&scoped=true&"
import script from "./RateView.vue?vue&type=script&lang=js&"
export * from "./RateView.vue?vue&type=script&lang=js&"
import style0 from "./RateView.vue?vue&type=style&index=0&id=5e368202&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e368202",
  null
  
)

export default component.exports